import whiteEventsIcon from "./white_events.png";
import darkEventsIcon from "./dark_events.png";
import whiteBuildingIcon from "./white_estate_nature.png";
import darkBuildingIcon from "./dark_estate_nature.png";
import whiteFilmIcon from "./white_cartography_commercial.png";
import darkFilmIcon from "./dark_cartography_commercial.png";
import whiteJournalismIcon from "./white_journalism.png";
import darkJournalismIcon from "./dark_journalism.png";
import whiteSportsIcon from "./white_sports.png";
import darkSportsIcon from "./dark_sports.png";
import whiteAgricultureIcon from "./white_agriculture.png";
import darkAgricultureIcon from "./dark_agriculture.png";
import whiteEnergyIcon from "./white_energy.png";
import darkEnergyIcon from "./dark_energy.png";
import whiteDroneIcon from "./white_drone.png";
import darkDroneIcon from "./dark_drone.png";
import whiteInsuranceIcon from "./white_insurances.png";
import darkInsuranceIcon from "./dark_insurances.png";
import filterIcon from "./filterIcon.png";

// Export all icons
export default {
  whiteEventsIcon,
  darkEventsIcon,
  whiteBuildingIcon,
  darkBuildingIcon,
  whiteFilmIcon,
  darkFilmIcon,
  whiteJournalismIcon,
  darkJournalismIcon,
  whiteSportsIcon,
  darkSportsIcon,
  whiteAgricultureIcon,
  darkAgricultureIcon,
  whiteEnergyIcon,
  darkEnergyIcon,
  whiteDroneIcon,
  darkDroneIcon,
  whiteInsuranceIcon,
  darkInsuranceIcon,
  filterIcon,
};
